import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";

const ConfirmationDialog = ({ open, onClose, onConfirm,  title, statement, okButtonColor}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title || " Confirmation Dialog"}</DialogTitle>
      <DialogContent dividers>
        <Typography>
                   {statement || "Are you sure you want to proceed?"}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color={okButtonColor || "primary"}>Ok</Button>

      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
